import React from 'react';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  const cards = [
    {
      title: "Today's Follow-Ups",
      desc: "Pending reminders & customer follow-ups",
      icon: "fas fa-bell",
      color: "from-amber-500 to-orange-500",
      link: "/followups"
    },
    {
      title: "Quotation List",
      desc: "View and manage all quotations",
      icon: "fas fa-list-alt",
      color: "from-purple-500 to-indigo-500",
      link: "/quotations"
    },
    {
      title: "Quotation Maker",
      desc: "Create new quotation for customers",
      icon: "fas fa-plus-circle",
      color: "from-pink-500 to-rose-500",
      link: "/maker"
    },
    {
      title: "Price Check",
      desc: "Quickly check item prices",
      icon: "fas fa-tags",
      color: "from-orange-500 to-amber-500",
      link: "/price-check"
    },
    {
      title: "Price Change",
      desc: "Update product pricing",
      icon: "fas fa-edit",
      color: "from-gray-500 to-slate-500",
      link: "/price-change"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-purple-950 to-indigo-950 text-white overflow-hidden relative">
       {/* Background Orbs */}
       <div className="fixed inset-0 pointer-events-none z-0">
        <div className="orb absolute w-96 h-96 top-20 left-20 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full blur-3xl opacity-30 animate-[float_20s_infinite_ease-in-out]"></div>
        <div className="orb absolute w-80 h-80 bottom-10 right-10 bg-gradient-to-r from-indigo-600 to-cyan-600 rounded-full blur-3xl opacity-30 animate-[float_20s_infinite_ease-in-out] delay-[-5s]"></div>
       </div>

      <div className="container mx-auto px-6 py-12 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
        
           <p className="text-xl text-purple-200 opacity-80">
             Avantica Pumps Dashboard
           </p>
        </div>

        {/* Dashboard Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {cards.map((card, idx) => (
            <Link to={card.link} key={idx} className="group">
              <div className="glass h-full p-8 rounded-3xl border border-white/10 hover:border-purple-500/50 shadow-2xl transition-all duration-300 transform hover:-translate-y-2 hover:shadow-purple-500/20 relative overflow-hidden">
                
                {/* Gradient Overlay on Hover */}
                <div className={`absolute inset-0 bg-gradient-to-br ${card.color} opacity-0 group-hover:opacity-10 transition-opacity duration-500`}></div>
                
                <div className="relative z-10">
                   <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${card.color} flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                      <i className={`${card.icon} text-3xl text-white`}></i>
                   </div>
                   
                   <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-purple-200 transition-colors">
                     {card.title}
                   </h3>
                   <p className="text-purple-200/70 text-sm group-hover:text-purple-100 transition-colors">
                     {card.desc}
                   </p>
                </div>
                
                {/* Arrow Icon */}
                <div className="absolute bottom-8 right-8 text-white/20 group-hover:text-white group-hover:translate-x-2 transition-all duration-300">
                  <i className="fas fa-arrow-right text-2xl"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <style jsx>{`
        .glass {
          background: rgba(255, 255, 255, 0.03);
          backdrop-filter: blur(16px);
        }
      `}</style>
    </div>
  );
};

export default Dashboard;
